import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'
import { AnalyticsAircraftRouter } from './aircraft/_router'
import { AnalyticsAirportRegionRouter } from './airport-region/_router'
import { AnalyticsCrewRouter } from './crew/_router'
import { AnalyticsMemberRouter } from './members/_router'

const Index = lazy(() => import('./Index'))

export const AnalyticsRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--analytics']}>
    <Route index element={<Index />} />
    <Route path='members/*' element={<AnalyticsMemberRouter />} />
    <Route path='aircraft/*' element={<AnalyticsAircraftRouter />} />
    <Route path='crew/*' element={<AnalyticsCrewRouter />} />
    <Route path='airport-region/*' element={<AnalyticsAirportRegionRouter />} />
  </SubRouter>
))
